import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { ProMethodSection } from './components/ProMethodSection';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-charcoal overflow-x-hidden selection:bg-coral/30 selection:text-charcoal" data-id="element-0">
      <SocialProofToast data-id="element-1" />
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPointsSection data-id="element-5" />
        <ProductIntroSection data-id="element-6" />
        <TomosSection data-id="element-7" />
        <BonosSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <ProMethodSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <UrgencySection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <FinalCTASection data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}